import { useCallback } from 'react';
import { State } from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/platform-enums/location_feature_enum.pb';
import { useScopedAppFlagStore } from '@frontend/scope';

const enableStatesOfCF = [State.ACTIVE, State.TRIAL, State.PROMOTE];

// TODO: Remove this hook once we have fully switched to using feature readiness API
export const useOnlineSchedulingCustomizationFlag = () => {
  const { getCustomizationFlagLocationMap } = useScopedAppFlagStore();

  const getCFLocationMap = useCallback(() => {
    const cfLocationMap = getCustomizationFlagLocationMap('onlinescheduling') || {};
    return Object.fromEntries(
      Object.entries(cfLocationMap).map(([locationId, cf]) => [
        locationId,
        cf?.state ? enableStatesOfCF.includes(cf.state) : false,
      ])
    );
  }, [getCustomizationFlagLocationMap]);

  const getOnlineSchedulingEnabledLocations = useCallback(() => {
    const onlineSchedulingCFLocationMap = getCFLocationMap();
    const onlineSchedulingCFEnabledLocationIds =
      Object.keys(onlineSchedulingCFLocationMap).filter((locationId) => !!onlineSchedulingCFLocationMap[locationId]) ||
      [];
    return onlineSchedulingCFEnabledLocationIds;
  }, [getCFLocationMap]);

  return { getOnlineSchedulingEnabledLocations };
};
